module.exports = require('./src/wordCloud');